import _asyncToGenerator from "D:/workBag/projectDemo/vuedemo10/xmmanagement/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.error.cause.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-4e2cd24a"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "div-body"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "card-header"
  }, [/*#__PURE__*/_createElementVNode("span", null, "个人信息")], -1);
});

var _hoisted_3 = {
  class: "el-dropdown-link"
};
var _hoisted_4 = {
  class: "item dis-sp"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "用户账号", -1);
});

var _hoisted_6 = {
  class: "item dis-sp"
};

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "用户昵称", -1);
});

var _hoisted_8 = {
  class: "item dis-sp"
};

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "手机号码", -1);
});

var _hoisted_10 = {
  class: "item dis-sp"
};

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "所属部门", -1);
});

var _hoisted_12 = {
  class: "item dis-sp"
};

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "所属角色", -1);
});

var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "card-header"
  }, [/*#__PURE__*/_createElementVNode("span", null, "基本资料")], -1);
});

import { onMounted, ref } from '@vue/runtime-core';
import router from '@/router';
import { ElMessage, ElMessageBox } from 'element-plus';
import { getUserInfo, saveUserInfo, updatePassword } from '@/api/xmManagement/user/user';
import { unref } from '@vue/reactivity';
import { empty, isNull_Any } from '@/utils';
export default {
  __name: 'user_center',
  setup: function setup(__props) {
    var circleUrl = 'https://tse4-mm.cn.bing.net/th/id/OIP-C.JPaFw0vH2f6Qy44aUfZ4jgAAAA?w=204&h=204&c=7&r=0&o=5&dpr=1.5&pid=1.7';
    var userInfo = ref({
      username: undefined,
      nickname: undefined,
      phone: undefined,
      department: undefined,
      role: undefined
    });
    var activeName = ref('first');
    var formRefPassword = ref();
    var formRef = ref();
    var requestForm = ref({
      nickname: undefined,
      phone: undefined
    });
    var passwordForm = ref({
      oldPassword: undefined,
      newPassword: undefined,
      confirmPassword: undefined
    });

    var checkPassword = function checkPassword(rule, value, callback) {
      if (isNull_Any(value)) {
        callback(new Error('确认密码不能为空!'));
        return;
      }

      if (value === passwordForm.value.newPassword) {
        callback();
      } else {
        callback(new Error('确认密码不相等'));
      }
    };

    var checkPasswordT1 = function checkPasswordT1(rule, value, callback) {
      if (isNull_Any(value)) {
        callback(new Error('修改的密码不能为空'));
        return;
      }

      if (value === passwordForm.value.oldPassword) {
        callback(new Error('修改的密码不允许和原密码相等'));
      } else {
        callback();
      }
    };

    var rulesPassword = ref({
      oldPassword: [{
        required: true,
        message: '请输入原密码',
        trigger: 'blur'
      }],
      newPassword: [{
        required: true,
        trigger: 'blur',
        validator: checkPasswordT1
      }],
      confirmPassword: [{
        required: true,
        trigger: 'blur',
        validator: checkPassword
      }]
    });
    var rules = ref({
      nickname: [{
        required: true,
        message: '请输入昵称',
        trigger: 'blur'
      }],
      phone: [{
        required: true,
        message: '请输入手机号',
        trigger: 'blur'
      }]
    });

    var handleClick = function handleClick() {
      clearForm();
    };

    var closeTo = function closeTo() {
      router.back();
    }; // 获取个人信息


    var getUserInfoEvent = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getUserInfo({});

              case 2:
                userInfo.value = _context.sent;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getUserInfoEvent() {
        return _ref.apply(this, arguments);
      };
    }();

    var clearForm = function clearForm() {
      formRef.value.resetFields();
      formRefPassword.value.resetFields();
    };

    var savePasswordEvent = function savePasswordEvent() {
      var forms = unref(formRefPassword.value);
      if (!forms) return;
      forms.validate( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (valid) {
                    ElMessageBox.confirm('确认修改密码?', {
                      confirmButtonText: '确认',
                      cancelButtonText: '取消'
                    }).then(function () {
                      updatePassword({
                        oldPassword: empty(passwordForm.value.oldPassword),
                        newPassword: empty(passwordForm.value.newPassword)
                      }).then(function (res) {
                        ElMessage.success('修改成功');
                        getUserInfoEvent();
                        clearForm();
                      }).catch(function (err) {
                        ElMessage.error('修改失败');
                      });
                    }).catch(function (e) {});
                  }

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    };

    var saveUserInfoEvent = function saveUserInfoEvent() {
      var forms = unref(formRef.value);
      if (!forms) return;
      forms.validate( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(valid) {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (valid) {
                    ElMessageBox.confirm('确认保存?', {
                      confirmButtonText: '确认',
                      cancelButtonText: '取消'
                    }).then(function () {
                      saveUserInfo(requestForm.value).then(function (res) {
                        ElMessage.success('保存成功');
                        getUserInfoEvent();
                        clearForm();
                      }).catch(function (err) {
                        ElMessage.error('保存失败');
                      });
                    }).catch(function (e) {});
                  }

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x2) {
          return _ref3.apply(this, arguments);
        };
      }());
    };

    onMounted(function () {
      getUserInfoEvent();
    });
    return function (_ctx, _cache) {
      var _component_el_avatar = _resolveComponent("el-avatar");

      var _component_el_card = _resolveComponent("el-card");

      var _component_el_col = _resolveComponent("el-col");

      var _component_el_input = _resolveComponent("el-input");

      var _component_el_form_item = _resolveComponent("el-form-item");

      var _component_el_button = _resolveComponent("el-button");

      var _component_el_button_group = _resolveComponent("el-button-group");

      var _component_el_form = _resolveComponent("el-form");

      var _component_el_tab_pane = _resolveComponent("el-tab-pane");

      var _component_el_tabs = _resolveComponent("el-tabs");

      var _component_el_row = _resolveComponent("el-row");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
        gutter: 20
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            span: 6,
            xs: 24
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_card, {
                class: "box-card"
              }, {
                header: _withCtx(function () {
                  return [_hoisted_2];
                }),
                default: _withCtx(function () {
                  return [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_avatar, {
                    size: 130,
                    src: circleUrl
                  })]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("span", null, _toDisplayString(_unref(userInfo).username), 1)]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("span", null, _toDisplayString(_unref(userInfo).nickname), 1)]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("span", null, _toDisplayString(_unref(userInfo).phone), 1)]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("span", null, _toDisplayString(_unref(userInfo).department), 1)]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("span", null, _toDisplayString(_unref(userInfo).role), 1)])];
                }),
                _: 1
              })];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 18,
            xs: 24,
            style: {
              "min-height": "300px"
            }
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_card, {
                class: "box-card"
              }, {
                header: _withCtx(function () {
                  return [_hoisted_14, _createVNode(_component_el_tabs, {
                    modelValue: _unref(activeName),
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
                      return _isRef(activeName) ? activeName.value = $event : null;
                    }),
                    class: "demo-tabs",
                    onTabClick: handleClick
                  }, {
                    default: _withCtx(function () {
                      return [_createVNode(_component_el_tab_pane, {
                        label: "基本资料",
                        name: "first"
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form, {
                            model: _unref(requestForm),
                            ref_key: "formRef",
                            ref: formRef,
                            rules: _unref(rules),
                            "label-width": "80px",
                            "label-position": "right",
                            style: {
                              "width": "100%"
                            }
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_form_item, {
                                label: "昵称:",
                                prop: "nickname"
                              }, {
                                default: _withCtx(function () {
                                  return [_createVNode(_component_el_input, {
                                    style: {
                                      "max-width": "400px"
                                    },
                                    modelValue: _unref(requestForm).nickname,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                                      return _unref(requestForm).nickname = $event;
                                    }),
                                    maxlength: "30"
                                  }, null, 8, ["modelValue"])];
                                }),
                                _: 1
                              }), _createVNode(_component_el_form_item, {
                                label: "手机号:",
                                prop: "phone"
                              }, {
                                default: _withCtx(function () {
                                  return [_createVNode(_component_el_input, {
                                    style: {
                                      "max-width": "400px"
                                    },
                                    modelValue: _unref(requestForm).phone,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                                      return _unref(requestForm).phone = $event;
                                    })
                                  }, null, 8, ["modelValue"])];
                                }),
                                _: 1
                              }), _createVNode(_component_el_form_item, {
                                label: "操作"
                              }, {
                                default: _withCtx(function () {
                                  return [_createVNode(_component_el_button_group, {
                                    class: "ml-2"
                                  }, {
                                    default: _withCtx(function () {
                                      return [_createVNode(_component_el_button, {
                                        type: "primary ",
                                        onClick: saveUserInfoEvent
                                      }, {
                                        default: _withCtx(function () {
                                          return [_createTextVNode(" 保存")];
                                        }),
                                        _: 1
                                      }), _createVNode(_component_el_button, {
                                        onClick: closeTo
                                      }, {
                                        default: _withCtx(function () {
                                          return [_createTextVNode("关闭")];
                                        }),
                                        _: 1
                                      })];
                                    }),
                                    _: 1
                                  })];
                                }),
                                _: 1
                              })];
                            }),
                            _: 1
                          }, 8, ["model", "rules"])];
                        }),
                        _: 1
                      }), _createVNode(_component_el_tab_pane, {
                        label: "修改密码",
                        name: "second"
                      }, {
                        default: _withCtx(function () {
                          return [_createVNode(_component_el_form, {
                            model: _unref(passwordForm),
                            ref_key: "formRefPassword",
                            ref: formRefPassword,
                            rules: _unref(rulesPassword),
                            "label-width": "120px",
                            "label-position": "right",
                            style: {
                              "width": "100%"
                            }
                          }, {
                            default: _withCtx(function () {
                              return [_createVNode(_component_el_form_item, {
                                label: "原密码:",
                                prop: "oldPassword"
                              }, {
                                default: _withCtx(function () {
                                  return [_createVNode(_component_el_input, {
                                    style: {
                                      "max-width": "400px"
                                    },
                                    modelValue: _unref(passwordForm).oldPassword,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                                      return _unref(passwordForm).oldPassword = $event;
                                    })
                                  }, null, 8, ["modelValue"])];
                                }),
                                _: 1
                              }), _createVNode(_component_el_form_item, {
                                label: "新密码:",
                                prop: "newPassword"
                              }, {
                                default: _withCtx(function () {
                                  return [_createVNode(_component_el_input, {
                                    style: {
                                      "max-width": "400px"
                                    },
                                    modelValue: _unref(passwordForm).newPassword,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                                      return _unref(passwordForm).newPassword = $event;
                                    })
                                  }, null, 8, ["modelValue"])];
                                }),
                                _: 1
                              }), _createVNode(_component_el_form_item, {
                                label: "确认密码:",
                                prop: "confirmPassword"
                              }, {
                                default: _withCtx(function () {
                                  return [_createVNode(_component_el_input, {
                                    style: {
                                      "max-width": "400px"
                                    },
                                    modelValue: _unref(passwordForm).confirmPassword,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
                                      return _unref(passwordForm).confirmPassword = $event;
                                    })
                                  }, null, 8, ["modelValue"])];
                                }),
                                _: 1
                              }), _createVNode(_component_el_form_item, {
                                label: "操作"
                              }, {
                                default: _withCtx(function () {
                                  return [_createVNode(_component_el_button_group, {
                                    class: "ml-2"
                                  }, {
                                    default: _withCtx(function () {
                                      return [_createVNode(_component_el_button, {
                                        type: "primary ",
                                        onClick: savePasswordEvent
                                      }, {
                                        default: _withCtx(function () {
                                          return [_createTextVNode(" 保存")];
                                        }),
                                        _: 1
                                      }), _createVNode(_component_el_button, {
                                        onClick: closeTo
                                      }, {
                                        default: _withCtx(function () {
                                          return [_createTextVNode("关闭")];
                                        }),
                                        _: 1
                                      })];
                                    }),
                                    _: 1
                                  })];
                                }),
                                _: 1
                              })];
                            }),
                            _: 1
                          }, 8, ["model", "rules"])];
                        }),
                        _: 1
                      })];
                    }),
                    _: 1
                  }, 8, ["modelValue"])];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      })]);
    };
  }
};